import React from 'react'


export const TarjetasKits = () => {
  return (
    <div className='DivProductos'>
        <div className='producto'>
            <section className='imgProducto'>
                <img className='imagenpersona' src="https://res.cloudinary.com/dlohqvzri/image/upload/v1682022987/niko/pintucaritas_camabx.webp" alt="" />
            </section>
            <section className='nombreProducto'>
                <hr className='hrProductoKit'/>
                <h3 className='nombreProductoh3'>Pintucaritas</h3>
            </section>
        </div>
        <div className='producto'>
            <section className='imgProducto'>
                <img className='imagenpersona' src="https://res.cloudinary.com/dlohqvzri/image/upload/v1683224453/niko/camisas_neon_lk9cb1.jpg" alt="" />
            </section>
            <section className='nombreProducto'>
                <hr className='hrProductoKit'/>
                <h3 className='nombreProductoh3'>Camisas Neon</h3>
            </section>
        </div>
        <div className='producto'>
            <section className='imgProducto'>
                <img className='imagenpersona' src="https://res.cloudinary.com/dlohqvzri/image/upload/v1682367695/niko/camisasuperheroe_fyujnq.webp" alt="" />
            </section>
            <section className='nombreProducto'>
                <hr className='hrProductoKit'/>
                <h3 className='nombreProductoh3'>Camisas Super Heroes</h3>
            </section>
        </div>
        <div className='producto'>
            <section className='imgProducto'>
                <img className='imagenpersona' src="https://res.cloudinary.com/dlohqvzri/image/upload/v1682368267/niko/gorras_baandn.webp" alt="" />
            </section>
            <section className='nombreProducto'>
                <hr className='hrProductoKit'/>
                <h3 className='nombreProductoh3'>Gorras gran Aventura</h3>
            </section>
        </div>
        <div className='producto'>
            <section className='imgProducto'>
                <img className='imagenpersona' src="https://res.cloudinary.com/dlohqvzri/image/upload/v1682368483/niko/espuma_y3z0jg.webp" alt="" />
            </section>
            <section className='nombreProducto'>
                <hr className='hrProductoKit'/>
                <h3 className='nombreProductoh3'>Espumas</h3>
            </section>
        </div>
        <div className='producto'>
            <section className='imgProducto'>
                <img className='imagenpersona' src="https://res.cloudinary.com/dlohqvzri/image/upload/v1683224534/niko/barras_neon_hvawbo.jpg" alt="" />
            </section>
            <section className='nombreProducto'>
                <hr className='hrProductoKit'/>
                <h3 className='nombreProductoh3'>Barras Neon</h3>
            </section>
        </div>
        <div className='producto'>
            <section className='imgProducto'>
                <img className='imagenpersona' src="https://res.cloudinary.com/dlohqvzri/image/upload/v1683224456/niko/tula_led_p6znua.webp" alt="" />
            </section>
            <section className='nombreProducto'>
                <hr className='hrProductoKit'/>
                <h3 className='nombreProductoh3'>Tula</h3>
            </section>
        </div>
        <div className='producto'>
            <section className='imgProducto'>
                <img className='imagenpersona' src="https://res.cloudinary.com/dlohqvzri/image/upload/v1682368613/niko/collar_akm7wh.webp" alt="" />
            </section>
            <section className='nombreProducto'>
                <hr className='hrProductoKit'/>
                <h3 className='nombreProductoh3'>Collar Hawaiano</h3>
            </section>
        </div>
    </div>
  )
}
